import { render, staticRenderFns } from "./rosterspotGantt.vue?vue&type=template&id=55ffef34&scoped=true"
import script from "./rosterspotGantt.vue?vue&type=script&lang=js"
export * from "./rosterspotGantt.vue?vue&type=script&lang=js"
import style0 from "./rosterspotGantt.vue?vue&type=style&index=0&id=55ffef34&prod&lang=css"
import style1 from "./rosterspotGantt.vue?vue&type=style&index=1&id=55ffef34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ffef34",
  null
  
)

export default component.exports